import { atom } from 'jotai';
import { createUnwrappedPitchEventsAtom, getPitchMarkersEvents } from '@/utils/atoms/vis';
import { playerComparisonEventMarkersForMetricAtom } from '../queries/player/playerEventDataComparison';

export const playerComparisonPitchEventsAtom = atom(async get =>
  getPitchMarkersEvents(get, playerComparisonEventMarkersForMetricAtom),
);

export const playerComparisonUnwrappedPitchEventsAtom = createUnwrappedPitchEventsAtom(playerComparisonPitchEventsAtom);
